import React from 'react';
import Head from 'next/head';
import Header from 'components/ScienceFiguresJapan/Header';
import MainContent from 'components/ScienceFiguresJapan/MainContent';
import PageFooter from 'components/PageFooter';
import useIsMobile from 'hooks/useIsMobile';
import PageFooterMobile from 'components/PageFooterMobile';

export default function ScienceFigures() {
  const isMobile = useIsMobile();

  return (
    <>
      <Header />

      <Head>
        <title> 効果的な科学イラストを数分で作成 | Mind the Graph</title>

        <meta
          key="description"
          name="description"
          content="Illustrate any topic or subject you need. Browse through the world's largest scientifically accurate illustration gallery - curated by scientists."
        />
        <meta name="keywords" content="サイエンス イラスト, 医学 イラスト" />
      </Head>

      <MainContent />

      {!isMobile ? <PageFooter localeProp="ja" /> : <PageFooterMobile localeProp="ja" />}
    </>
  );
}
